import { axiosInterceptor } from "../authInterceptor";
import environment from "../../../../environments/environment";

 async function postAuditLogsLoginandLogout(auditLogVO: any) {
    try {
      const auditLogResponse = await axiosInterceptor.post(`${environment.postAuditLogInandLogOut}`, auditLogVO);
      return auditLogResponse;
    } catch (error: any) {
      return error;
    }
  }


 export async function saveAuditlog(auditLogVO: any) {
    try {
      await postAuditLogsLoginandLogout(auditLogVO);  
    } catch (error) {
      console.error("Error while posting the login details:", error);
    }
  }
